(function() {
  var today = new Date().toISOString().split('T')[0];
  if (localStorage.getItem('cf_session_date') !== today) {
    localStorage.removeItem('cf_collections');
    localStorage.removeItem('cf_last_product');
    localStorage.setItem('cf_session_date', today);
  }
  var path = window.location.pathname;
  if (path.indexOf('/collections/') !== -1) {
    var parts = path.split('/collections/');
    if (parts[1]) {
      var handle = parts[1].split('/')[0].split('?')[0];
      var skip = ['tienda-1','tienda-dsct-auto','mayorista','gift-card','promociones-cyber'];
      if (handle && skip.indexOf(handle) === -1) {
        var cols = JSON.parse(localStorage.getItem('cf_collections') || '[]');
        cols = cols.filter(function(c){ return c !== handle; });
        cols.unshift(handle);
        if (cols.length > 5) cols = cols.slice(0, 5);
        localStorage.setItem('cf_collections', JSON.stringify(cols));
      }
    }
  }
  if (path.indexOf('/products/') !== -1) {
    var parts2 = path.split('/products/');
    if (parts2[1]) {
      var productHandle = parts2[1].split('/')[0].split('?')[0];
      if (productHandle) localStorage.setItem('cf_last_product', productHandle);
    }
  }
})();